export const apiPaymentSection = '/checkout';

export const apiPaymentPath = apiPaymentSection + '/:accessKey';
export const apiPaymentSuccessPath = apiPaymentSection + '/:accessKey/success';
export const apiPaymentProcessingPath = apiPaymentSection + '/:accessKey/processing';
export const apiPaymentPendingActionPath = apiPaymentSection + '/:accessKey/pending-action';
